import { FiliereTemplate } from '@/components/FiliereTemplate';

const filiereData = {
  name: "Sciences Économiques",
  icon: "📊",
  tagline: "Formez-vous aux métiers de l'économie, de la finance et de la gestion d'entreprise",
  duree: "3 à 5 ans",
  diplome: "Licence/Master",
  mode: "Présentiel",
  nombreDebouches: "15",
  description: "La filière Sciences Économiques offre une formation complète dans les domaines de l'économie, de la finance et de la gestion d'entreprise. Notre programme allie théorie économique, analyse financière et pratiques managériales pour former des professionnels polyvalents et compétents. Les étudiants développent une compréhension approfondie des mécanismes économiques, des marchés financiers et des stratégies de gestion moderne.",
  objectifs: [
    "Maîtriser les fondamentaux de la théorie économique et de la gestion",
    "Développer des compétences en analyse financière et comptable",
    "Comprendre les dynamiques des marchés et de la concurrence",
    "Acquérir des compétences en prise de décision stratégique",
    "Maîtriser les outils de gestion moderne et les systèmes d'information"
  ],
  programme: [
    {
      titre: "Licence 1 & 2",
      matieres: [
        "Microéconomie et Macroéconomie",
        "Comptabilité générale et analytique",
        "Mathématiques et statistiques",
        "Introduction au droit des affaires",
        "Informatique de gestion",
        "Communication professionnelle"
      ]
    },
    {
      titre: "Licence 3 & Master",
      matieres: [
        "Économie internationale",
        "Finance d'entreprise",
        "Contrôle de gestion",
        "Marketing stratégique",
        "Gestion de projet",
        "Analyse des données"
      ]
    }
  ],
  debouches: [
    { titre: "Analyste financier", description: "Analyse des investissements et des marchés financiers" },
    { titre: "Contrôleur de gestion", description: "Pilotage de la performance et analyse des coûts" },
    { titre: "Consultant en gestion", description: "Conseil en stratégie et optimisation" },
    { titre: "Économiste", description: "Analyse économique et prévisions" },
    { titre: "Chef de projet", description: "Gestion et coordination de projets d'entreprise" },
    { titre: "Directeur administratif", description: "Gestion administrative et financière" }
  ],
  competences: [
    "Analyse économique et financière avancée",
    "Maîtrise des outils de gestion et de pilotage",
    "Capacité de synthèse et de prise de décision",
    "Compétences en négociation et communication",
    "Expertise en systèmes d'information de gestion",
    "Vision stratégique et sens du business"
  ]
};

export default function EconomieGestion() {
  return <FiliereTemplate filiere={filiereData} />;
}